import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { SkyNavbarItemComponent } from './navbar-item.component';
import { SkyNavbarComponent } from './navbar.component';


export class SkyNavbarModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [
    SkyNavbarComponent,
    SkyNavbarItemComponent
  ],
  imports: [
    CommonModule,
    RouterModule
  ],
  exports: [
    SkyNavbarComponent,
    SkyNavbarItemComponent
  ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
